import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { slideInAnimation } from '../../animations';

@Component({
  templateUrl: './admin-layout.component.html',
  styleUrls: [
    '../../../assets/css/admin/fontawesome/scss/font-awesome.scss',
    '../../../assets/css/admin/select2CalculadoraCupratheme/src/select2-calculadora-cupra-theme.scss',
    './admin-layout.component.scss',
    '../../../assets/css/admin/admin.scss'
    ],
  encapsulation: ViewEncapsulation.None,
  animations: [
    slideInAnimation
  ]
})

export class AdminLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    $('body').addClass('admin-layout');
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

}
